import { useId, useState, type ReactNode } from 'react';
import { ContextPanel, DetailsButton, type ItemContext } from '@/ui/context';

/**
 * A row of a table a screen draws itself (the economics matrix, a report's
 * tool table), with the disclosure the shared `Table` gives its own rows
 * (ADR-0155): the first cell carries the button, and what it opens sits in a
 * row of its own beneath, across every column.
 */
export function ExplainedRow({
  context,
  colSpan,
  lead,
  children,
  testId,
  leadClassName = 'px-3 py-2.5 text-dense',
}: {
  context: ItemContext;
  colSpan: number;
  /** The first cell's content. */
  lead: ReactNode;
  /** The remaining cells. */
  children: ReactNode;
  testId?: string | undefined;
  leadClassName?: string | undefined;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <>
      <tr className="border-b border-line last:border-b-0" data-testid={testId}>
        <td className={`sticky left-0 z-[1] bg-page ${leadClassName}`}>
          <span className="flex items-center gap-1">
            <DetailsButton open={open} onToggle={() => setOpen((o) => !o)} controls={id} label={context.subject.title} />
            {lead}
          </span>
        </td>
        {children}
      </tr>
      {open && (
        <tr className="border-b border-line last:border-b-0">
          <td colSpan={colSpan} className="p-4">
            <ContextPanel context={context} id={id} />
          </td>
        </tr>
      )}
    </>
  );
}
